module.exports = __webpack_public_path__ + "img/securitydetailsList3.3b59c10c.png";